module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABtSURBVHgB7ZNhCsAgCIVfnmQ3rJtvN3AabkSDlbmf+yBQ8D3UEGhgAQP6GkIQEsMsb7+ceUBTo5oCCzY4UY1qp+Z+MeHwDlKkg7sNLPLJCNQ55vo1k/nDQEjO/N+BuYZ3cKwek2o1KHaRXuo5n/HL4D1EUnp6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/Booking/calendar-icon.png
// module id = 441
// module chunks = 0